import React from 'react';

const SvgEyeClosed = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 13 11" {...props}>
    <path
      d="M4.04 5.333a2.014 2.014 0 0 1 2.242-2.008L7.87 1.738a8.155 8.155 0 0 0-1.81-.193c-2.483 0-4.524.953-5.904 3.233-.208.34-.208.768 0 1.11a6.882 6.882 0 0 0 1.663 1.9l2.234-2.233a2.174 2.174 0 0 1-.013-.222zm7.925-.555a6.882 6.882 0 0 0-1.663-1.901L8.067 5.11a2.016 2.016 0 0 1-2.23 2.23L4.25 8.927a8.168 8.168 0 0 0 1.81.192c2.482 0 4.524-.953 5.905-3.233.207-.34.207-.768 0-1.108zM1.263 10.635a.505.505 0 0 1-.358-.862L10.5.178a.505.505 0 0 1 .714.714L1.62 10.488a.504.504 0 0 1-.356.147z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgEyeClosed;
